import { createSelector } from 'reselect';
import { getProp } from '../../utilities';

const seatingsDomainSelector = state => state.seatings;

export const seatingLayoutSelector = id => {
  return createSelector(
    seatingsDomainSelector,
    state => {
      const substate = getProp(state,['seatsById',id]);
      return Object.keys(getProp(substate, ['position'], [])).map(letter => {
        const row = {
          name: letter,
        };
        row.seats = Object.keys(getProp(substate, ['position', letter], [])).map(index => {
          return {
            ...getProp(substate, ['position', letter, index]),
            index: parseInt(index, 10) - 1,
          };
        });
        return row;
      });
    }
  );
}

export const seatingsIsFetchingSelector = createSelector(
  seatingsDomainSelector,
  substate => substate.isFetching,
)



// WEBPACK FOOTER //
// ./src/components/Bus/selectors.js